<script setup>
    import { computed, ref, toRefs } from "vue";
    import SortTableAscending from "@/assets/sort_folder/sort_table_ascending.svg";
    import SortTableDescending from "@/assets/sort_folder/sort_table_descending.svg";
    import SortTableEmpty from "@/assets/sort_folder/sort_table_empty.svg";
    import SortTableHover from "@/assets/sort_folder/sort_table_hover.svg";

    const props = defineProps({
        column: {
            type: Object,
            required: true,
        },
        sorted: {
            type: String,
        },
        direction: {
            type: String,
        },
    });

    const emit = defineEmits(["sort"]);

    const { column, sorted, direction } = toRefs(props);

    const hover = ref(false);

    function sort() {
        if (column.value.sort) {
            emit("sort", column.value.sort);
        }
    }

    function mouseover() {
        hover.value = true;
    }

    function mouseleave() {
        hover.value = false;
    }

    const getIcon = computed(() => {
        if (sorted.value === column.value.sort) {
            if (direction.value === "-") {
                return SortTableDescending;
            } else {
                return SortTableAscending;
            }
        }

        if (hover.value) {
            return SortTableHover;
        }

        return SortTableEmpty;
    });
</script>

<template>
    <span
        class="kliniken-table-header-cell"
        @click="sort()"
        @mouseover="mouseover()"
        @mouseleave="mouseleave()"
        :class="{ sort: column.sort }"
    >
        {{ column.title }}
        <img v-if="column.sort" :src="getIcon" alt="" />
    </span>
</template>

<style scoped lang="scss">
    @import "@/style/_variables.scss";

    .kliniken-table-header-cell {
        white-space: nowrap;
        font-size: 14px;
        line-height: 16px;
        color: $color-text-header;
        align-items: center;
        padding: 2px;
        margin-left: 8px;

        &.sort {
            cursor: pointer;

            &:hover {
                background-color: $color-theah-background;
                border-radius: 5px;
                width: max-content;
            }
        }

        img {
            margin-left: 5px;
        }
    }
</style>
